import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { LoginService } from '../../services/login.service';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { UtilityService } from '../../services/utility.service';
import * as _ from 'lodash';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
declare var $: any;

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  @Input('user') user;
  @Input('data') data;
  @Input('proflilePicOnly') proflilePicOnly;
  @Input('profilePicture') profilePicture;
  @Input('color') color;
  @Input('isTopNav') isTopNav;
  @Input('singleJob') jobId
  @Input('redirect') noRedirect
  @Output() someEvent = new EventEmitter();

  isTrainer: boolean;
  isClient: boolean;
  isLearner: boolean;
  currentUser;
  userRole;
  name: any;
  isAdmin: boolean;
  learnerId;
  singleJobId
  isRedirect
  isIncidentUser: boolean;
  isAssetUser: boolean
  isSingleAssetUser: boolean
  isPendingUser: boolean

  private logSubscription: Subject<any> = new Subject<any>();

  constructor(
    public _loginService: LoginService,
    private router: Router,
    public _utilityService: UtilityService
  ) {
    this._loginService.getLoggedInUser().subscribe((user) => {
      // console.log("login user details", user);

      this.user = null;
      this.data = null;
      this.isTrainer = null;
      this.isAdmin = null;
      this.isLearner = null;
      this.isClient = null;
      this.isIncidentUser = null;
      this.user = user.jobs ? user.jobs.userRole[0] : ''
      // console.log('this.user', this.user)
      this.user = JSON.parse(localStorage.getItem('userRoles'))
      if (this.user.isLearner) {
        this.user = "learner"
      }
      else if (this.user.isAdmin || this.user.isManager) {
        this.user = "admin"
      }
      else if (this.user.isClient || this.user == "client") {
        this.user = "client"
      } else if (this.user.isOperative) {
        this.user = "oprative"
      }
      else {
        this.user = "trainer"
      }
      if (this.user.isIncidentUser) {
        this.user = 'incidentUser'
      }

      if (this.user.isAssetUser) {
        this.user = 'assetUser'
      }
      if (this.user.isSingleAssetUser) {
        this.user = 'singleAssetUser'
      }
      if (this.user == 'isStaff') {
        this.user = 'staff'
      }
      this.data = user.jobs
      // console.log("USer ===========+>", user, this.data, this.user);

      this.ngOnInit();
    })
    this.userRole = JSON.parse(localStorage.getItem('userRoles'))

  }

  ngOnDestroy() {

    this.logSubscription.next()
    this.logSubscription.complete()

  }

  ngOnInit() {

    // console.log("WHAT IS THE MAIN USER", this.data);

    this.currentUser = JSON.parse(localStorage.currentUser);
    this.userRole = JSON.parse(localStorage.getItem('userRoles'))
    if (!this.isTrainer && !this.isAdmin && !this.isLearner && !this.isClient && !this.isIncidentUser && !this.isAssetUser) {
      // console.log("this.user", this.user, this.data);

      switch (this.user) {
        case 'instructor':
          this.isTrainer = true;
          this.isLearner = false;
          if (this.data) {
            this.data = this.data._id.name ? this.data._id : this.data
          }
          break;

        case 'PendingUsers': {
          this.isTrainer = true;
          this.isLearner = false;
          this.isPendingUser = true
          if (this.data) {
            this.data = this.data._id.name ? this.data._id : this.data
          }
          break;
        }
        case 'incidentUser': {
          let userData = this.user;
          this.isLearner = false;
          this.isTrainer = false;
          this.isIncidentUser = true;
          if (this.data) {
          }
          break;
        }

        case 'assetUser': {

          let userData = this.user;
          this.isLearner = false;
          this.isTrainer = false;
          this.isAssetUser = true;
          if (this.data) {
            this.data._id = this.data.staffId
          }
          break;
        }
        case 'trainer':
          this.isTrainer = true;
          this.isLearner = false;
          this.data = this.data._id.name ? this.data._id : this.data
          break;
        case 'staff':
          this.isTrainer = true;
          this.isLearner = false;
          this.data = this.data._id.name ? this.data._id : this.data
          break;
        case 'mp':
          this.isTrainer = true;
          this.isLearner = false;
          this.data = this.data._id.name ? this.data._id : this.data
          break;
        case 'oprative':
          this.isTrainer = true;
          this.isLearner = false;
          this.data = this.data._id ? this.data : this.data
          break;
        case 'client':
          this.isClient = true;
          this.isLearner = false;
          break;
        case 'learner':
          this.name = (this.data && this.data.name) ? this.data.name : this.data && this.data.learnerName ? this.data.learnerName : ''
          if (this.data && this.data.userId) {
            this.learnerId = this.data.userId
          }
          if (this.data && this.data.learnerId) {
            this.learnerId = this.data.learnerId
          }
          if (this.data && (this.data._id && !this.data.learnerId)) {
            this.learnerId = this.data._id
          }
          this.isLearner = true;
          break;
        case 'admin':
          this.isAdmin = true
          this.isLearner = false;
          this.name = this.data ? this.data.name : ''
          break;


        default:
          this.isTrainer = true;
          this.isLearner = false;
          if (this.data)
            this.data = this.data._id.name ? this.data._id : this.data
          break;
      }

    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log("changes in user data", changes);

    if (changes.data && changes.data.currentValue) {
      this.data = changes.data.currentValue
      // console.log("value of single user", this.data);
      if (this.isAdmin && this.isTopNav) {
        this.name = this.data.name
      }
    }
    if (changes.jobId && changes.jobId.currentValue) {
      // console.log("its for multiple learners", changes.jobId.currentValue);
      this.singleJobId = changes.jobId.currentValue
      // console.log("its for multiple learners", this.singleJobId);

    }

    if (changes.noRedirect && changes.noRedirect.currentValue) {
      // console.log("hello here is the ...", changes.noRedirect.currentValue)
      this.isRedirect = changes.noRedirect.currentValue
    }

  }


  learnerDashboard(learnerId) {
    if (this.isRedirect != true) {
      this.router.navigate(['/learner/view/' + learnerId], { queryParams: { job: this.singleJobId } });
    }

  }



  incidentUserRedirection(id, user) {
    if (this.data.systemRole.includes("mp") || this.data.systemRole.includes("trainer") || this.data.systemRole.includes("learner") || this.data.systemRole.includes("IQA") || this.data.systemRole.includes("operative")) {

      this.router.navigate([this.data.redirectUrl], { queryParams: this.data && this.data.queryParams ? this.data.queryParams : {} });
    } else {
      // console.log("this is for only accident user");
      this._utilityService.handleSnackBar({ msg: "Not a system user!", button: "OK" })
    }
  }


  assetUserRedirection(id, data) {
    this.router.navigate(['/staff/' + data.staffId]);
  }

}
